/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for roleType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="roleType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="target"/&gt; &lt;enumeration value="input"/&gt; &lt;enumeration value="id"/&gt; &lt;enumeration value="exclude"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class RoleType extends Enum{

	enumValue = null;

	static  TARGET = RoleType.newLiteral("target");

	static  INPUT = RoleType.newLiteral("input");

	static  ID = RoleType.newLiteral("id");

	static  EXCLUDE = RoleType.newLiteral("exclude");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < RoleType.values().length); ++i) {
			if (RoleType.values()[i].enumValue == v) {
				return RoleType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("RoleType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/RoleType.js